import React from "react";
import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import { SERVICE_AREAS } from "../lib/content";

export default function ServiceAreas() {
  return (
    <section data-testid="service-areas" className="relative py-24 md:py-28 bg-[#F7F4F0] border-y border-black/8">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex items-center gap-3 text-[#B8965A] mb-6">
          <span className="block w-8 h-px bg-[#C9A86A]" />
          <span className="text-[11px] uppercase tracking-[0.3em]">Where We Work</span>
        </div>
        <h2 className="font-display-bold text-3xl md:text-4xl lg:text-5xl tracking-tighter text-[#0A0A0A] max-w-3xl">
          Sydney-wide service, <span className="font-serif-italic font-light text-[#B8965A]">deeply local.</span>
        </h2>
        <p className="mt-5 text-[#525252] max-w-2xl text-[15px] leading-relaxed">
          From eastern beaches to North Shore estates and Central Coast escapes —
          we bring our equipment, our craftsmen and our standards to your door.
        </p>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-y-3 gap-x-8">
          {SERVICE_AREAS.map((area) => (
            <Link
              key={area}
              to="/contact"
              data-testid={`area-${area.toLowerCase().replace(/\s+/g, "-")}`}
              className="group flex items-center gap-3 py-3 border-b border-black/12 text-[#0A0A0A]/75 hover:text-[#0A0A0A]"
            >
              <MapPin className="w-3.5 h-3.5 text-[#C9A86A]" />
              <span className="text-[14px]">{area}</span>
              <span className="ml-auto text-[#B8965A] opacity-0 group-hover:opacity-100 transition-opacity text-xs">
                →
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
